import React from 'react'
import { Box, Container, Button, Typography } from '@mui/material'
import { FormattedMessage } from 'react-intl'
import { IntlLink } from 'src/components/Common/IntlComponents'

const Error404 = () => {
  return (
    <Box sx={{ p: 1 }}>
      <Container>
        <Box
          component='img'
          src='https://meteor.stullercloud.com/das/133055963?fmt=smart-alpha&wid=680'
          sx={{ width: '100%', maxWidth: 680 }}
        />
        <Typography variant='h2' mb={2}>
          <FormattedMessage id='404.title' />
        </Typography>
        <Typography mb={3}>
          <FormattedMessage id='404.description' />
        </Typography>
        <Button size='large' component={IntlLink} to={'/'} variant='contained'>
          <FormattedMessage id='checkout.goHome' />
        </Button>
      </Container>
    </Box>
  )
}
export default Error404
